<template>
  <VDialog
    v-model="_dialog"
    persistent
    width="600"
  >
    <VCard>
      <VToolbar
        dark
        color="primary"
      >
        <VBtn
          icon
          @click.prevent="_dialog = false"
        >
          <VIcon>
            close
          </VIcon>
        </VBtn>
        <VToolbarTitle>
          Compose New Mass Messages
        </VToolbarTitle>
      </VToolbar>
      <VForm>
        <VContainer
          ma-0
          pa-0
        >
          <VLayout
            row
            fill-height
            wrap
            style="margin: 0px"
          >
            <VFlex xs12>
              <VContainer>
                <ContactAutoComplete
                  v-if="_dialog"
                  ref="contactAutoComplete"
                  :items="queriedContacts"
                  :get-gql-query="contactGqlQuery"
                  :get-query-variables="getQueryContactsVariables"
                  :get-query-status="getSearchingStatus"
                  :set-query-status="setSearchingStatus"
                  :update-context-variable="updateContactContextVariable"
                  :parse-data="parseContactData"
                  :clear-all="clearSearch"
                />
              </VContainer>
            </VFlex>
            <VFlex xs12>
              <TextBox
                ref="textBox"
                :submit-text="submitMassText"
                :sending="sending"
                :uploading-file="uploadingFile"
                show-file
              />
            </VFlex>
          </VLayout>
        </VContainer>
      </VForm>
    </VCard>
  </VDialog>
</template>

<script>
import ContactAutoComplete from './ContactAutoComplete'
import ACTIVE_CONTACTS_BY_NAME_OR_NUMBER_QUERY from '@/backend/graphql/contact/ActiveContactsByNameOrNumber.gql'
import TextBox from '@/components/TextBox'
import { massMessagePendingType } from '@/store/modules/message'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ComposeNewMassMessagesDialog',
  components: { ContactAutoComplete, TextBox },
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      contactGqlQuery: ACTIVE_CONTACTS_BY_NAME_OR_NUMBER_QUERY,
      limit: 30,
      offset: 0,
      orderBy: 'name',
      queryString: ''
    }
  },
  computed: {
    ...mapGetters({
      queriedContacts: 'contact/getQueriedContacts',
      sending: 'message/getMassSendingStatus',
      uploadingFile: 'message/getUploadingFile'
    }),
    _dialog: {
      get () {
        return this.dialog
      },
      set (val) {
        this.$emit('update:dialog', val)
      }
    }
  },
  methods: {
    ...mapActions({
      clearSearch: 'contact/clearSearch',
      initSearch: 'contact/initSearch',
      sendMassMessages: 'message/sendMassMessages',
      sendMassMMS: 'message/sendMassMMS'
    }),
    getSearchingStatus () {
      return this.$store.getters['contact/getSearchingStatus']
    },
    setSearchingStatus (val) {
      this.$store.dispatch('contact/setSearchingStatus', { val })
    },
    getQueryContactsVariables () {
      return {
        limit: this.limit,
        offset: this.offset,
        orderBy: this.orderBy,
        isDelete: 0,
        queryString: this.queryString
      }
    },
    updateContactContextVariable (key, value) {
      if (this.hasOwnProperty(key)) {
        this[key] = value
      }
    },
    getContactItems (data) { return data.listContacts.results },
    getTotalQueryCount (data) { return data.listContacts.totalCount },
    parseContactData (data) {
      this.initSearch({
        newContacts: this.getContactItems(data),
        totalCount: this.getTotalQueryCount(data)
      })
    },
    submitMassText () {
      if (this.sending) return
      this.sendMassText()
    },
    sendMassText () {
      const pendingType = massMessagePendingType.send
      const text = this.$refs.textBox.$refs.userInput.textContent.replace(/\s/g, '')
      const selectedContacts = this.$refs.contactAutoComplete.select
      if (this.$refs.textBox.file && selectedContacts.length > 0) {
        this.sendMassMMS({
          msgBody: this.$refs.textBox.$refs.userInput.textContent,
          file: this.$refs.textBox.file,
          selectAll: false,
          selectedIds: selectedContacts,
          unselectedIds: [],
          contactId: selectedContacts[0],
          pendingType,
          contactsCount: selectedContacts.length
        })
        this.$refs.textBox.$refs.userInput.innerHTML = ''
      } else if (selectedContacts.length > 0 && text && text.length > 0) {
        this.sendMassMessages({
          msgBody: this.$refs.textBox.$refs.userInput.textContent,
          selectAll: false,
          selectedIds: selectedContacts,
          unselectedIds: [],
          pendingType,
          contactsCount: selectedContacts.length
        })
        this.$refs.textBox.$refs.userInput.innerHTML = ''
      }
    }
  }
}
</script>

<style scoped>

</style>
